export enum iThemeSetting {
    Dark = 'Dark',
    Light = 'Light',
    OS = 'OS',
}
